/**
 * Constantes partagées pour les composants UI
 */

export const FR_DAYS_SHORT = [
  'Dim',
  'Lun',
  'Mar',
  'Mer',
  'Jeu',
  'Ven',
  'Sam',
] as const;

export const FR_MONTHS_SHORT = [
  'Jan',
  'Fév',
  'Mar',
  'Avr',
  'Mai',
  'Juin',
  'Juil',
  'Août',
  'Sep',
  'Oct',
  'Nov',
  'Déc',
] as const;

export const CHART_PERIOD_OPTIONS = [
  '7 derniers jours',
  '30 derniers jours',
  'Ce mois-ci',
  '3 derniers mois',
  '6 derniers mois',
] as const;

export const MENU_DROPDOWN_GAP = 6;
export const MENU_DROPDOWN_VIEWPORT_PADDING = 16;
